//============================
//# csgenpaymode
//============================ 

export default interface PayMode {
    id: number;
    name: string;
}

export const PayModeDefaultProps: PayMode = {
    id: 1,
    name: "-"
}